export default __webpack_public_path__ + "static/media/S_Sol.58654229.mp3";